module.exports = __webpack_public_path__ + "img/jd.483e9983.png";